import React, { useState, useEffect } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import IconButton from '@material-ui/core/IconButton'

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import CloseIcon from '@material-ui/icons/Close'

import '../filesMenu.css'

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
    width: 120,
    margin: 'auto',
    '& .MuiOutlinedInput-root': {
      height: 37,
    },
    '& .MuiSelect-outlined': {
      height: 37,
    },
    '& .MuiSelect-select': {
      height: 37,
    },
  },
  selectEmpty: {
    // marginTop: theme.spacing(2),
  },
}))

function RenameModal(props) {
  const [folderName, setFolderName] = useState('')
  const [open, setOpen] = useState(false)

  // const classes = useStyles()

  useEffect(() => {
    setFolderName(props.folderId)
  }, [props.folderId])

  const changeName = (event) => {
    const { value } = event.target
    setFolderName(value.replace(new RegExp(/[^a-zA-Z0-9_ ]/, 'ig'), ''))
  }

  const handleName = () => {
    const updateFeatures = props.features
    updateFeatures.features.map((val, i) => {
      if (val.properties.id === props.folderId) {
        val.properties.id = folderName
      }
    })

    // const updateLabels = props.projects
    // updateLabels.map((val, i) => {
    //   if (val.projectName === props.folderId) {
    //     val.projectName = folderName
    //   }
    // })

    props.setProjects(
      props.projects.map((val, i) => {
        if (val.projectName === props.folderId) {
          val.projectName = folderName
          return val
        } else {
          return val
        }
      }),
    )

    // props.setProjects(updateLabels)
    props.setProject(folderName)
    props.setRenameModal(false)
  }

  return (
    <div className="save-file-modal" style={{ height: '230px' }}>
      <IconButton size="small" component="span" className="sf-modal-close" onClick={() => props.setRenameModal(false)}>
        <CloseIcon />
      </IconButton>
      <h3>Rename</h3>
      <div style={{ display: 'flex', flexFlow: 'column', gap: '15px' }}>
        <div style={{ display: 'flex' }}>
          <label style={{ height: 'fit-content', marginRight: '10px', alignSelf: 'center' }}>Folder Name:</label>
          <TextField
            id="filled-name"
            size="small"
            // style={{ width: '100%' }}
            variant="outlined"
            value={folderName}
            onChange={changeName}
          />
        </div>

        <button
          class="files-manager-btn ripple"
          style={{ width: '140px', margin: 'auto', display: 'block' }}
          onClick={() => handleName()}
        >
          Rename
        </button>
      </div>
      <div className="modal-footer" style={{ height: 'fit-content' }}>
        <InfoOutlinedIcon
          style={{ position: 'absolute', right: '5px', top: '5px', color: '#999', height: '22px', width: '22px' }}
        />
        <p className="modal-footer-txt" style={{ margin: '10px 30px 0px 30px' }}>
          <b>Accepted Characters:</b>
        </p>
        <p className="modal-footer-txt" style={{ margin: '5px 30px 10px 30px' }}>
          The project names only accept alpha-numeric characters and the underscore character.
        </p>
      </div>
    </div>
  )
}

export default RenameModal
